import angular from 'angular';

export default class MessageParser {
    static $inject = ['$translate'];

    constructor($translate) {
        'ngInject';
        this._$translate = $translate;
    }

    addExtendedProperties(message) {
        this.addFriendlyReasonDescription(message);
        this.addStorageDate(message);
        return message;
    }

    async addFriendlyReasonDescription(message) {
        if (!message.reason || !message.reason.code) return message;

        const recipientNotFound = await this._$translate('utils.errorMsg.38');
        switch (message.reason.code) {
            case 42:
                message.friendlyReasonDescription = recipientNotFound;
                break;
            default:
                message.friendlyReasonDescription = message.reason.description;
                break;
        }
        message.friendlyReasonDescription = `${message.friendlyReasonDescription} (Cód. ${message.reason.code})`;
        return message;
    }

    addStorageDate(message) {
        if (!message.metadata && !message.metadata['#envelope.storageDate']) return;
        message.storageDate = new Date(message.metadata['#envelope.storageDate']);
        delete message.metadata['#envelope.storageDate'];
        if (angular.equals(message.metadata, {})) delete message.metadata;

        return message;
    }
}
